import { SubmissionInfo } from '../../../../submission-list-view.types';
import { SubmissionV2ListViewState } from '../../store.type';

interface UpdateLoadedSubmissionIdsPayload {
  loadedSubmissions: SubmissionInfo[];
  selectedSubmissions: SubmissionInfo[];
}

type UpdateLoadedSubmissionIdsResults = Pick<
  SubmissionV2ListViewState,
  'loadedSubmissions' | 'isSelectAllIndeterminate'
>;

export function updateLoadedSubmissionIds({
  loadedSubmissions,
  selectedSubmissions,
}: UpdateLoadedSubmissionIdsPayload): UpdateLoadedSubmissionIdsResults {
  return {
    loadedSubmissions,
    isSelectAllIndeterminate: selectedSubmissions.length > 0 && selectedSubmissions.length < loadedSubmissions.length,
  };
}
